function DarkCta() {
  return (
    <section className="cta-section">
      <div className="container">
        <div className="cta-content">
          <span className="cta-tag">WEBSITES • MARKETING • AI AUTOMATION</span>

          <h2>
            Your Competitors Are Already Growing Online.
            <br />
            Don't Get Left Behind.
          </h2>

          <p>
            Build a stronger digital presence, attract more customers and
            automate repetitive work with solutions designed for business
            growth.
          </p>

          <div className="cta-stats">
            <div>
              <h3>3</h3>
              <span>Core Services</span>
            </div>

            <div>
              <h3>24/7</h3>
              <span>Automation Capability</span>
            </div>

            <div>
              <h3>100%</h3>
              <span>Custom Solutions</span>
            </div>
          </div>

          <a href="#contact" className="cta-button">
            Start Your Project
          </a>
        </div>
      </div>
    </section>
  );
}

export default DarkCta;
